import { OptionDto } from "@/dtos";
import { VehicleGeofenceType } from "@/helpers/types";


const geofence = [
    { value: parseInt(VehicleGeofenceType.VIRTUAL), label: 'VIRTUAL' },
    { value: parseInt(VehicleGeofenceType.PHYSICS), label: 'FÍSICA' }
] as OptionDto[];

export const getGeofenceTypeOptions = (): OptionDto[] => {
    return geofence;
}

export const getGeofence = (value: number): OptionDto => {
    return geofence.find((x) => x.value == value) ?? geofence[0];
}


export const getGeofenceVehicle = (value: number): VehicleGeofenceType => {
    switch (value) {
        case 1001:
             return VehicleGeofenceType.VIRTUAL;
        case 1002:
             return VehicleGeofenceType.PHYSICS;
        default:
             return VehicleGeofenceType.VIRTUAL;
    }
}